import React, { useEffect } from 'react';

// Non-production environments get a corner ribbon, a faint page watermark and a tab-title prefix so
// nobody mistakes QA or a local build for production. Detection is by hostname so it needs no extra
// build configuration; REACT_APP_ENV_LABEL can force a label (e.g. "STAGING") if ever needed.
export const getEnvironmentLabel = () => {
  if (process.env.REACT_APP_ENV_LABEL) {
    return process.env.REACT_APP_ENV_LABEL;
  }
  const host = (typeof window !== 'undefined' && window.location.hostname) || '';
  if (host === 'localhost' || host === '127.0.0.1') {
    return 'LOCAL';
  }
  if (/(^|\.)qa\./i.test(host)) {
    return 'QA';
  }
  if (/(^|\.)dev\./i.test(host)) {
    return 'DEV';
  }
  return null;
};

const EnvironmentBanner = () => {
  const label = getEnvironmentLabel();

  useEffect(() => {
    if (!label) {
      return undefined;
    }
    const prefix = `[${label}] `;
    const original = document.title;
    if (!document.title.startsWith(prefix)) {
      document.title = prefix + document.title;
    }
    return () => {
      document.title = original;
    };
  }, [label]);

  if (!label) {
    return null;
  }

  return (
    <>
      <div className="env-ribbon" title={`You are on the ${label} environment`}>
        {label} ENVIRONMENT
      </div>
      <div className="env-watermark" aria-hidden="true">
        {Array.from({ length: 9 }).map((_, i) => (
          <span key={i}>{label}</span>
        ))}
      </div>
    </>
  );
};

export default EnvironmentBanner;
